import Vue from 'vue';
import Vuex from 'vuex';
import appsData from './modules/apps-data';
import apps from './modules/apps';
import dictionary from './modules/dictionary';
import pages from './modules/pages';
import pagination from './modules/pagination';
import sidebar from './modules/sidebar';
import fixedWidget from './modules/fixed-widget';
import share from './modules/share';
import help from './modules/help';
import youtubeVideo from './modules/youtube-video';
import content from './modules/content';
import contacts from './modules/contacts';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
	modules: {
		appsData,
		apps,
		dictionary,
		pages,
		pagination,
		sidebar,
		fixedWidget,
		share,
		help,
		youtubeVideo,
		content,
		contacts,
	},
	strict: debug,
});



// WEBPACK FOOTER //
// ./assets/_js/store/index.js